import React, { useContext, useEffect, useState, useRef } from "react";
import PageName from "../Utils/PageName";
import { Link } from "react-router-dom";
import axios from "axios";
import { userContext } from "../../context/userContext";
import { ToastContainer, toast } from "react-toastify";
import ReactDOM from "react-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { businessContext } from "../../context/businessContext";
import CircularLoader from "../../Backend/Components/CircularLoader/CircularLoader";
import Swal from 'sweetalert2';
import {useTranslation} from "react-i18next";
import { environmentVariables } from "../../config/env.config";
import { getUserPermission } from "../../utils/utility";

function Categories_admin() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);
  const [isCategory, setIsCategory] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [isStatus, setIsStatus] = useState(false);
  const [selectedParent, setSelectedParent] = useState("");
  const [iconFile, setIconFile] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [bgColor, setBgColor] = useState("#ffffff");
  const [textColor, setTextColor] = useState("#000000");
  const createCategoryModalRef = useRef(null);
  const tableExtensions = { export: false, print: false };
  const { t } = useTranslation();
  const [isUpdate, setIsUpdate] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [parentCategories, setParentCategories] = useState([]);
  const storedUserData = localStorage.getItem("user");
  const userDataObject = JSON.parse(storedUserData);
  const iconInputRef = useRef();
const bannerInputRef = useRef();

    const fetchCategories = async () => {
      try {
        axios
          .get(`${baseUrl}api/v1/mktcategory/getAllmktCategories`, {
            headers: {
              _token: userData?.token,
            },
            withCredentials: true,
          })
          .then((response) => {
            setData(response?.data?.data);
            setIsLoading(false)
             const transformedData = response?.data?.data.map((category) => ({
                id: category.id,
                name: category.category_Name,
              }));
      // console.log(transformedData,"transformedData==>");
      
       setParentCategories(transformedData);
  
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false)
          });
      } catch (err) { }
    };

  useEffect(() => {
    fetchCategories();
    return () => {
      $(createCategoryModalRef.current).off("hidden.bs.modal");
    };
  }, []);

const categoryHandler = async()=>{
 try{
const response = await axios.get(`${environmentVariables?.apiUrl}api/v1/business/allCategory`);
    const transformedData = response.data.map((category) => ({
      id: category.id,
      name: category.category_Name,
    }));
      // console.log(transformedData,"transformedData==>");
      
      //  setParentCategories(transformedData);
  }catch(err){  
      console.log(err, "error");
       toast.error("Failed to load parent categories", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    
  }
}


useEffect(()=>{
categoryHandler();
},[])

  const handleClearState = () => {
    try {
    
      setCategoryName("");
      setSelectedParent("");
      setIconFile(null);
      setBannerFile(null);
      setBgColor("");
      setTextColor("");
      setIsUpdate(false);
      setCategoryId("");
      setIsCategory(false);

        if (iconInputRef.current) iconInputRef.current.value = "";
  if (bannerInputRef.current) bannerInputRef.current.value = "";
    } catch (err) {
      console.log(err, "erororo");
    }
  };

  const handleEdit = (el) => {
    try {
      setIsUpdate(true);
      setCategoryId(el?.id);
      setCategoryName(el?.category_Name);
      setSelectedParent(el?.parent_id);
      setBgColor(el?.bgcolor);
      setTextColor(el?.color);
      setIsCategory(true);
      setIsStatus(false);
      $(createCategoryModalRef.current).modal("show");
    } catch (err) {
      console.log(err, "Errorro");
    }
  };

const handleDelete = async (d) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You won't be able to revert this!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const response = await axios.delete(
        `${environmentVariables.apiUrl}api/v1/mktcategory/deleteCategory/${d.id}`
      );

      if (response.status === 200) {
        toast.success("Category deleted successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        fetchCategories();
      }
    }
  } catch (err) {
    console.error(err);

    if (err.response?.status === 400 && err.response?.data?.error) {
      toast.error(err.response.data.error, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    } else {
      toast.error("Failed to delete category", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
  }
};

  const columns = [
    {
      name: "Name",
      selector: (row) =>  row?.category_Name,
      sortable: true,
    },
    {
      name: "Parent Category",
      selector: (row) => row?.parentCategory?.category_Name,
      sortable: true,
    },
     {
      name: "Background colour",
      selector: (row) => row?.bgcolor,
      sortable: true,
    },
     {
      name: "Colour",
      selector: (row) => row?.color,
      sortable: true,
    },
  //  {
  //     name: "Icon",
  //     selector: (row) => row.icon,
  //     sortable: false,
  //     cell: (row) => (
  //       <img 
  //         src={mockIcons[row.icon]} 
  //         alt={row.name} 
  //         style={{ 
  //           width: "30px", 
  //           height: "30px",
  //           borderRadius: "50%",
  //           objectFit: "cover"
  //         }} 
  //       />
  //     ),
  //     width: "70px"
  //   },
    // {
    //   name: "Action",
    //   sortable: false,
    //   cell: (d) => [
    //     <>
    //       <i
    //         key={`trash-${d.id}`}
    //         className="fas fa-trash-alt"
    //         onClick={() => handleDelete(d)}
    //       ></i>{" "}
    //       &nbsp;&nbsp; &nbsp;{" "}
    //       <i
    //         key={`edit-${d.id}`}
    //         className="first fas fa-pen"
    //         onClick={() => {
    //           handleEdit(d);
    //         }}
    //       ></i>
    //     </>,
    //   ],
    // },
  ];

    const isSuperAdmin = userDataObject?.user_type === "super_admin";
    const hasPermission = getUserPermission(userDataObject, 165);

    if (isSuperAdmin || hasPermission) {
    columns.push({
      name: "Action",
      sortable: false,
      cell: (d, index) => {
        if (isSuperAdmin) {
          return (
            <>
              <i
            key={`trash-${d.id}`}
            className="fas fa-trash-alt"
            onClick={() => handleDelete(d)}
          ></i>{" "}
          &nbsp;&nbsp; &nbsp;{" "}
          <i
            key={`edit-${d.id}`}
            className="first fas fa-pen"
            onClick={() => {
              handleEdit(d);
            }}
          ></i>
            </>
          );
        } else if (hasPermission) {
          return (
            <>
              <i
            key={`edit-${d.id}`}
            className="first fas fa-pen"
            onClick={() => {
              handleEdit(d);
            }}
          ></i>
            </>
          );
        } else {
          return null;
        }
      },
      minWidth: "1px",
    });
  }

  const customStyles = {
    headRow: {
      style: {
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
        fontSize:"15px",
      },
    },
    rows: {
      style: {
        padding: "20px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px ",
      },
    },
  };

  const tableData = {
    columns,
    data,
  };


  useEffect(() => {
  const $modal = $(createCategoryModalRef.current);
  $modal.on("hidden.bs.modal", () => {
    handleClearState(); 
  });

  return () => {
    $modal.off("hidden.bs.modal");
  };
}, []);


  const handleSubmit = async () => {
  try {
    if (!categoryName?.trim()) {
      return toast.error("Category name is mandatory");
    }
    if (!iconFile && !isUpdate) {
      return toast.error("Icon file is mandatory");
    }

    setIsStatus(true);

    const formData = new FormData();
    formData.append("category_Name", categoryName);
    formData.append("bgcolor", bgColor);
    formData.append("color", textColor);
    // formData.append("parent_id", selectedParent || "");
    formData.append("parent_id", selectedParent ? selectedParent : "0");


    if (iconFile) formData.append("category_icon", iconFile);
    if (bannerFile) formData.append("category_banner", bannerFile);

    const config = {
      headers: { "Content-Type": "multipart/form-data" },
    };

    let response;
    if (isUpdate && categoryId) {
      response = await axios.put(
        `${baseUrl}api/v1/mktcategory/editcategory/${categoryId}`,
        formData,
        config
      );
    } else {
      response = await axios.post(`${baseUrl}api/v1/mktcategory/addcategory`, formData, config);
    }

    toast.success(`Category ${isUpdate ? "updated" : "created"} successfully`);
    handleClearState();
    $(createCategoryModalRef.current).modal("hide");
    fetchCategories();
    categoryHandler();
  } catch (error) {
    const msg =
      error.response?.data?.error || "Something went wrong. Try again.";
    toast.error(msg);
  } finally {
    setIsStatus(false);
  }
};


  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };
  
  return (
    <>
      <PageName PageName="Categories" />

      <article>
        <div className="main">
          <div >
            <button
            data-bs-toggle="modal" data-bs-target="#createCategoryModal"
              id="Currency_admin_button"
              type="button"
              className="save-cta"
              // onClick={() => setIsCategory(!isCategory)}
              onClick={() => {
                handleClearState(); 
                setIsCategory(true); 
                $(createCategoryModalRef.current).modal("show");
              }}
            >
              + Add Categories
            </button>
          </div>
          
          {isLoading ? (
            <CircularLoader size={40} />
          ) : (
            <DataTableExtensions 
              {...tableData} 
              filterPlaceholder="Search Categories"
              customStyles={customStyles}
              {...tableExtensions}
            >
              <DataTable
                columns={columns}
                data={data}
                noHeader
                defaultSortField="id"
                sortIcon={<SortIcon />}
                defaultSortAsc={true}
                pagination
                highlightOnHover
                dense
                paginationComponentOptions={{
                  ...paginationOptions,
                }}
                customStyles={customStyles}
                noDataComponent={<div style={{padding:"24px"}}>{t("No_records_found")}</div>}
              />
            </DataTableExtensions>
          )}
        </div>

        <div
          className={`modal fade ${isCategory ? "show" : ""}`}
          id="createCategoryModal"
          tabIndex="-1"
          ref={createCategoryModalRef}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isUpdate && categoryId ? "Edit" : "Create New"} Category
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleClearState}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Parent Category</label>
                    <select
                      className="form-control"
                      value={selectedParent}
                      onChange={(e) => setSelectedParent(e.target.value)}
                      style={{appearance:"auto", cursor:"pointer"}}
                    >
                      <option value="">Select Parent Category</option>
                      {parentCategories?.map((category) => (
                        
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Category Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter category name"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Icon (only SVG)</label>
                    <input
                      type="file"
                      ref={iconInputRef}
                      className="form-control"
                      accept="image/*"
                      onChange={(e) => setIconFile(e.target.files[0])}
                    />
                    {isUpdate && !iconFile && (
                      <small className="text-muted">Current icon will be kept if no new file is selected</small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Banner (Only PNG)</label>
                    <input
                      type="file"
                      ref={bannerInputRef} 
                      className="form-control"
                      accept="image/*"
                      onChange={(e) => setBannerFile(e.target.files[0])}
                    />
                    {isUpdate && !bannerFile && (
                      <small className="text-muted">Current banner will be kept if no new file is selected</small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Background colour</label>
                    <div className="input-group" style={{gap:"15px"}}>
                      <input
                        type="text"
                        className="col-md-3 form-control"
                        value={bgColor}
                        placeholder="#ffffff, #000000"
                        onChange={(e) => setBgColor(e.target.value)}
                        
                      />
                        <input
                      type="color"
                      className="col-md-3 form-control form-control-color"
                      value={bgColor}
                      onChange={(e) => setBgColor(e.target.value)}
                      title="Choose background color"
                      style={{ height:"auto", border: 'none' }}
                    />
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">Text colour</label>
                    <div className="input-group">
                      <input
                        type="text"
                       className="col-md-3 form-control"
                        value={textColor}
                        onChange={(e) => setTextColor(e.target.value)}
                        placeholder="#ffffff, #000000"
                      />

                        <input
                      type="color"
                      className="col-md-3 form-control form-control-color"
                      value={textColor}
                      onChange={(e) => setTextColor(e.target.value)}
                      title="Choose text color"
                      style={{ height:"auto", border: 'none' }}
                    />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer" id="Coupanadmin_Button_Wrapper">
                <button
                  id="Coupan_edit_Button"
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  {isStatus ? (
                    <CircularLoader size={20} />
                  ) : isUpdate && categoryId ? (
                    "Update"
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}

export default Categories_admin;